/** Поле с автодополнением по справочнику. Пустая строка снимает фильтр. */

import { useEffect, useRef, useState } from "react";

type Props = {
  label: string;
  value: string | null;
  placeholder?: string;
  onChange: (value: string | null) => void;
  search: (query: string) => Promise<string[]>;
};

export function Suggest({ label, value, placeholder, onChange, search }: Props) {
  const [draft, setDraft] = useState(value ?? "");
  const [options, setOptions] = useState<string[]>([]);
  const [open, setOpen] = useState(false);
  const holder = useRef<HTMLDivElement>(null);

  useEffect(() => setDraft(value ?? ""), [value]);

  useEffect(() => {
    if (!open) return;
    const timer = setTimeout(() => {
      search(draft)
        .then(setOptions)
        .catch(() => setOptions([]));
    }, 200);
    return () => clearTimeout(timer);
  }, [draft, open, search]);

  useEffect(() => {
    const onClickOutside = (event: MouseEvent) => {
      if (holder.current && !holder.current.contains(event.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  const pick = (option: string) => {
    setDraft(option);
    setOpen(false);
    onChange(option);
  };

  return (
    <div className="field" ref={holder}>
      <label className="field__label">{label}</label>
      <div className="field__control">
        <input
          className="input"
          value={draft}
          placeholder={placeholder ?? "не выбран"}
          onFocus={() => setOpen(true)}
          onChange={(event) => setDraft(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              setOpen(false);
              onChange(draft.trim() || null);
            }
            if (event.key === "Escape") setOpen(false);
          }}
        />
        {value && (
          <button
            type="button"
            className="field__clear"
            title="снять фильтр"
            onClick={() => {
              setDraft("");
              onChange(null);
            }}
          >
            ×
          </button>
        )}
        {open && options.length > 0 && (
          <ul className="suggest">
            {options.map((option) => (
              <li key={option}>
                <button type="button" onMouseDown={() => pick(option)}>
                  {option}
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
